const debounce = (func, wait, immediate) => {
  let timeout;
  return function() {
    const context = this; const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

const getInitials = (name) => {
  return name
    .split(' ')
    .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
    .join('');
};

const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const generateTimes = (step) => {
  const dt = new Date(1970, 0, 1);
  const rc = [];
  while (dt.getDate() === 1) {
    rc.push(dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }));
    dt.setMinutes(dt.getMinutes() + step);
  }
  return rc;
};

const stringToColor = function(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }
  return color;
};

const renderFormulas = (context) => {
  context.$nextTick(() => {
    window.MathJax.typesetPromise();
  });
};

/**
 *
 * @param {Object} props
 * @param {String} props.elementId - The elementId to calculate max height
 * @param {Number} props.maxHeight - Max height allowed for the element
 * @param {Number} props.totalAvailableHeight - Total height available for element
 *
 * @returns {Number} Maximum height allowed to be occupied by the element's dropdown
 */
const getAAutocompleteDropdownMaxHeight = ({ elementId, maxHeight, totalAvailableHeight }) => {
  const element = document.getElementById(elementId);
  const screenTotalAvailableHeight = window.innerHeight;
  const elementHeight = element && element.offsetHeight;
  const heightToTop = element && element.offsetTop + 160;
  const result = screenTotalAvailableHeight - heightToTop - elementHeight;

  return result < maxHeight ? result : totalAvailableHeight;
};

const getValueOrDefault = (value, defaultValue) => {
  return value || defaultValue;
};

export {
  debounce,
  getInitials,
  getRandomColor,
  generateTimes,
  stringToColor,
  renderFormulas,
  getAAutocompleteDropdownMaxHeight,
  getValueOrDefault
};
